// extracted by mini-css-extract-plugin
export default {"whatsapp_bubble":"WhatsAppBubble_whatsapp_bubble__ZwpSY","float":"WhatsAppBubble_float__HJ63J"};